import { useParams } from "react-router-dom";
import { Alert, Skeleton } from "@mantine/core";
import PathologistReviewDetailPage from "./PathologistReviewDetailPage";
import { useCaseForPathologistReview } from "../../hooks/useWorkflows";
import LegacyPathologistCaseView from "../../components/admin/legacy-cases/LegacyPathologistCaseView";
import { useLegacyImportedCase } from "../../hooks/useLegacyCases";
import LegacyTechnicalReportNotice from "../../components/admin/legacy-cases/LegacyTechnicalReportNotice";
import { isLegacyTechnicalReportError } from "../../utils/legacyTechnicalReportError";

export default function PathologistReviewDetailRoute() {
  const { caseId } = useParams<{ caseId: string }>();
  const query = useCaseForPathologistReview(caseId);
  const legacy = useLegacyImportedCase(
    caseId || "",
    query.data?.isLegacyImported === true
  );

  if (query.isLoading)
    return <Skeleton height={480} role="status" aria-label="Loading case" />;
  if (
    caseId &&
    (legacy.data?.reportKind === "technical" ||
      isLegacyTechnicalReportError(query.error))
  )
    return <LegacyTechnicalReportNotice caseId={caseId} />;
  if (query.error)
    return (
      <Alert color="red" title="Case unavailable">
        The case could not be loaded. Return to the review queue and try again.
      </Alert>
    );
  if (
    query.data?.isLegacyImported &&
    caseId &&
    (legacy.data?.reportKind !== "pathology" ||
      legacy.data?.canIssueReportRevisions !== true)
  )
    return (
      <LegacyPathologistCaseView
        caseId={caseId}
        caseNumber={query.data.caseNumber}
      />
    );

  return <PathologistReviewDetailPage key={caseId} />;
}
